import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonComponentsModule } from '@app/modules/common/common.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CgvComponent } from './cgv.component';
export const routes: Routes = [
    {
        path: '',
        component: CgvComponent,
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        CommonComponentsModule,
        FormsModule,
        CommonModule
    ],
    declarations: [
        CgvComponent
    ],
    exports: [
    ]
})

export class CgvModule {

}
